import { XStack, YStack } from 'tamagui';

import { isEmpty } from '../../misc';
import { Icon, type IconType } from '../icons/Icon';
import { Shadows } from '../Shadows';
import { BodyLargeEmphasized, BodyMediumRegular } from '../text/Typography';

interface SelectTileProps {
    title: string;
    description?: string;
    icon: IconType;
    onPress: () => void;
    isSelected?: boolean;
    disabled?: boolean;
    iconLeft?: boolean;
}

export const SelectTile = ({
    title,
    description,
    icon,
    onPress,
    isSelected,
    disabled,
    iconLeft,
}: SelectTileProps) => {
    return (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            gap={14}
            padding={15}
            borderWidth={2}
            borderRadius={20}
            borderColor={isSelected ? '$black' : '$gray100'}
            backgroundColor={disabled ? '$gray100' : '$white'}
            flexDirection={iconLeft ? 'row-reverse' : 'row'}
            style={{ ...Shadows.SMALL }}
            hoverStyle={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            pressStyle={{ scale: disabled ? 1 : 0.99 }}
            animation="button"
            onPress={disabled ? () => {} : onPress}
        >
            <YStack flex={6}>
                <BodyLargeEmphasized color={disabled ? '$gray1000' : '$black'}>
                    {title}
                </BodyLargeEmphasized>
                {!isEmpty(description) && (
                    <BodyMediumRegular color="$gray1000">
                        {description}
                    </BodyMediumRegular>
                )}
            </YStack>
            <YStack height="100%" justifyContent="flex-start">
                <XStack
                    alignItems="center"
                    justifyContent="center"
                    borderRadius={12}
                    width={48}
                    height={48}
                    backgroundColor="$gray100"
                >
                    <Icon
                        icon={icon}
                        size={20}
                        color={disabled ? '$gray1000' : '$gray1200'}
                    />
                </XStack>
            </YStack>
        </XStack>
    );
};
